import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface TeacherShellProps {
  /** Optional header CTA, e.g. a "Sign in" link on public pages. */
  trailingNav?: ReactNode;
  children: ReactNode;
}

/**
 * Outer chrome for all /teacher/* pages.
 *
 * Brand colors mirror Explorers (amber primary, coral accent) so the
 * school product reads as part of the same family. Layout is desktop-
 * leaning since teachers will mostly be on laptops/whiteboards, but
 * still mobile-safe.
 */
export function TeacherShell({ trailingNav, children }: TeacherShellProps): JSX.Element {
  return (
    <div className="min-h-dvh bg-amber-50">
      <header className="border-b border-amber-100 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
          <Link
            to="/teacher"
            className="flex items-center gap-2 text-lg font-bold text-slate-900 hover:text-amber-700"
          >
            <span
              aria-hidden="true"
              className="inline-grid h-8 w-8 place-items-center rounded-xl bg-amber-500 text-white"
            >
              M
            </span>
            <span>Maysterko for Schools</span>
          </Link>
          {trailingNav && <nav className="flex items-center gap-3">{trailingNav}</nav>}
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
